import { render, staticRenderFns } from "./outcomeStockMovementCreatePage.vue?vue&type=template&id=b0ce2d60&"
import script from "./outcomeStockMovementCreatePage.vue?vue&type=script&lang=ts&"
export * from "./outcomeStockMovementCreatePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports